// Auto Order config
export const CONST_AUTO_MAX_END_DATE = 90;

// Day Trading config
export const CONST_DT_CUSTOM_ERROR_CODES = ['EC0008988', 'EC0008985', 'EC0008984'];

// Margin Trading config
export const CONST_MT_MULTIPLIER = 2.85;
